import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs, setDoc, doc }
    from "firebase/firestore";

import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { MdApps, MdArrowBackIos, MdClose, MdEdit, MdEditNote, MdPrint } from "react-icons/md";
import { Randomcode } from "../../components_root/rendom_code.js";
import { Save_log_history } from "../../log_history_root/save_log_history.js";

export default function Printsetting_edit() {
    const navigate = useNavigate();
    const [printid, setPrintid] = useState("");
    const servicetablename = "accountingfinancedb";
    const [IsLoading2, setIsLoading2] = useState(true);
    const [printdata, setPrintdata] = useState([]);
    const { Toastshow } = Toast();
    const [select_company_uid, setselect_company_uid] = useState(null);

    //
    const [printsize, setPrintsize] = useState();
    const [print_name, setPrint_name] = useState("");
    const [print_title, setPrint_title] = useState("");
    const [print_tagline, setPrint_tagline] = useState("");
    const [print_contactinfo, setPrint_contactinfo] = useState("");
    const [print_address, setPrint_address] = useState("");
    const [print_address_footer, setPrint_address_footer] = useState("");
    const [print_contact_info_footer, setPrint_contact_info_footer] = useState("");
    const [print_trams_footer, setPrint_terms_footer] = useState("");
    // ---------- Live vouchers load ----------

    useEffect(() => {
        const select_company_uid = Cookies.get("select_company_uid");
        setselect_company_uid(select_company_uid);
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("uid");

        if (uid) {
            setPrintid(uid);
        } else {
        }
    }, [window.location.search]);

    useEffect(() => {
        if (!select_company_uid) return;

        const q = query(
            collection(db, servicetablename, select_company_uid, "print_setting")
        );

        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
            if (!data.length) return;

            setPrintsize(data[0].printsize);
            setPrint_name(data[0].print_name || "");

            const settingArray = data[0].settingdata || [];

            // convert array to object
            const settingObj = Object.fromEntries(
                settingArray.map((item) => [item.key, item.value])
            );

            // USE settingObj HERE
            setPrint_title(settingObj.print_title || "");
            setPrint_tagline(settingObj.print_tagline || "");
            setPrint_contactinfo(settingObj.print_contactinfo || "");
            setPrint_address(settingObj.print_address || "");

            setPrint_address_footer(settingObj.print_address_footer || "");
            setPrint_contact_info_footer(settingObj.print_contact_info_footer || "");
            setPrint_terms_footer(settingObj.print_trams_footer || "");
        });

        return () => unsub();
    }, [select_company_uid]);


    //

    const set_print_setting = async () => {
        if (!print_name || !print_name.trim()) {
            Toastshow("Please enter print name");
            return;
        }
        if (!print_title || !print_title.trim()) {
            Toastshow("Please enter print title");
            return;
        }

        const servicetablename = "accountingfinancedb";
        const sessiontoken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");
        const select_company_uid = Cookies.get("select_company_uid");

        if (!sessiontoken) return { success: false, error: "Session expired. Please relogin." };
        if (!guid) return { success: false, error: "Login expired. Please relogin." };
        if (!select_company_uid) return { success: false, error: "Contact service provider." };

        const collectionval = collection(
            db,
            servicetablename,
            select_company_uid,
            "print_setting"
        );

        // Check duplicate
        const duplicateQuery = query(
            collectionval,
            where("print_name", "==", print_name)
        );

        const duplicateSnap = await getDocs(duplicateQuery);

        // check duplicates except current id
        const isDuplicate = duplicateSnap.docs.some(
            (doc) => doc.id !== printid
        );
        if (isDuplicate) {
            Toastshow("Print name is duplicate");
            return;
        }
        handle_Create(printid);
        // raw data
        // const settingdataRaw = {
        //     print_title,
        //     print_tagline,
        //     print_contactinfo,
        //     print_address,
        //     print_address_footer,
        //     print_contact_info_footer,
        //     print_trams_footer
        // };
        // // remove empty
        // const cleaned = Object.fromEntries(
        //     Object.entries(settingdataRaw).filter(
        //         ([_, v]) => v !== null && v !== undefined && v !== ""
        //     )
        // );

        // // convert into indexed array
        // const indexed = Object.entries(cleaned).map(([key, value], index) => ({
        //     index,
        //     key,
        //     value
        // }));

        // // update payload
        // const payload = {
        //     print_name,
        //     printsize,
        //     settingdata: indexed,    // <-- stored as index array       
        //     guid,
        //     status: false,
        //     companyuid: select_company_uid,
        //     date_time: new Date(),
        //     date_time_update: new Date()
        // };

        // const ref = doc(
        //     db,
        //     servicetablename,
        //     select_company_uid,
        //     "print_setting",
        //     printid
        // );

        // await setDoc(ref, payload, { merge: true });

        // Toastshow("Saved Successfully");
    };
    const handle_Create = async (docid) => {
        const logid = Randomcode(25);
        if (!print_name || !print_name.trim()) {
            Toastshow("Please print name");
            return;
        }
        const settingdataRaw = {
            print_title,
            print_tagline,
            print_contactinfo,
            print_address,
            print_address_footer,
            print_contact_info_footer,
            print_trams_footer
        };
        // remove empty
        const cleaned = Object.fromEntries(
            Object.entries(settingdataRaw).filter(
                ([_, v]) => v !== null && v !== undefined && v !== ""
            )
        );
        // convert into indexed array
        const indexed = Object.entries(cleaned).map(([key, value], index) => ({
            index,
            key,
            value
        }));
        const dataupdates = {
            log_id: logid,
            //
            print_name,
            printsize,
            settingdata: indexed,
            ...settingdataRaw,
            status: true,
            // Add other necessary fields here
        };
        create_log(logid, dataupdates, docid, "print_setting", print_name, printsize);
    };
    const create_log = async (logid, dataupdates, filedid, account_type, description, verify_note) => {

        const log_description = "account_type:" + account_type + ", " + description;
        const log_data = {
            logid,
            history_type: "authority",
            servicetablename: "accountingfinancedb",
            tablename: "print_setting",
            filedname: "printid",
            filedid: filedid,
            log_description,
            log_status: false,
            verify_status: false,
            verify_note,
            //change info            
            dataupdates,
           // accountguid,
            description: description,
            account_type: account_type,
        };
        const result = await Save_log_history(log_data);
        if (result.success) {
            //  navigate(-1);
            Toastshow("Saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    return (
        <div>
            <div className="b-bottom">
                <table>
                    <tr>
                        <td ><div
                            onClick={() => navigate(-1)}
                            className="button-ui0 text-h2 bold p-2 cursor fcap"
                        >
                            <MdArrowBackIos className="icon" />Print setting  edit
                        </div></td>
                        <td width={30}>
                            <div
                                onClick={() => navigate("/accounting?page=vouchers_master")}
                                className="button-ui0 p-2 cursor"
                            >
                                <MdClose className="icon" />
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
            <div className="post-container p-2">
                <div className="post_updates">
                    <div className="ui-items p-11 items-back items-back shadow">
                        <table>
                            <tr>
                                <td>
                                    <table className="table-fixed">
                                        <tr>
                                            <td  >
                                                <div
                                    
                                                    className={`fill bold  p-2 cursor ${printsize === "4INCH" ? "button-ui green-back" : "button-ui2"}`}
                                                >
                                                    <MdPrint className="icon" />
                                                    4 Inch
                                                </div>
                                            </td>

                                            <td  >
                                                <div
                                         
                                                    className={`fill  p-2 cursor ${printsize === "A4" ? "button-ui red-back" : "button-ui2"}`}
                                                >
                                                    <MdPrint className="icon" />
                                                    A4
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                    <div className="text-h3 text-off">
                                        {printsize === "4INCH" ? "4 inch: 100–110 mm (common for shipping labels)" :
                                            "A4 210 × 297 mm, Standard office paper used worldwide for letters, forms, printouts, and documents."}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input value={print_name} onChange={(e) => setPrint_name(e.target.value)} maxLength={30} placeholder="Print name for vocher" />
                                </td>
                            </tr>
                            <tr>
                                <td className="text-h2 bold">
                                    Print Header
                                </td>
                            </tr>
                            <tr>
                                <td className="text-h3 text-off">
                                    <table>
                                        <tr>
                                            <td>
                                                Title Company name*
                                            </td>
                                            <td width={30}>
                                                <div className="text-r bold">{print_title.length - 30}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input className="bold text-h1" value={print_title} onChange={(e) => setPrint_title(e.target.value)} maxLength={30} placeholder="Print title" />
                                </td>
                            </tr>
                            <tr>
                                <td className="text-h3 text-off">
                                    <table>
                                        <tr>
                                            <td>
                                                Tag line / Reg. Number option
                                            </td>
                                            <td width={30}>
                                                <div className="text-r bold">{print_tagline.length - 30}</div>
                                            </td>
                                        </tr>
                                    </table>

                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input className="text-h2"
                                        value={print_tagline} onChange={(e) => setPrint_tagline(e.target.value)}
                                        maxLength={30} placeholder="Print Tag line / Reg. Number" />
                                </td>
                            </tr>
                            <tr>
                                <td className="text-h3 text-off">

                                    <table>
                                        <tr>
                                            <td>
                                                Contact info option
                                            </td>
                                            <td width={30}>
                                                <div className="text-r bold">{print_contactinfo.length - 30}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input className="text-h2" maxLength={30}
                                        value={print_contactinfo} onChange={(e) => setPrint_contactinfo(e.target.value)}
                                        placeholder="Print contact info option" />
                                </td>
                            </tr>
                            <tr>
                                <td className="text-h3 text-off">

                                    <table>
                                        <tr>
                                            <td>
                                                Address
                                            </td>
                                            <td width={30}>
                                                <div className="text-r bold">{print_address.length - 100}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <textarea className="text-h2"
                                        value={print_address} onChange={(e) => setPrint_address(e.target.value)}
                                        maxLength={50} placeholder="Print address option" />
                                </td>
                            </tr>

                            <br />
                            <tr >
                                <td className="text-h2 bold">
                                    Print Footer   option
                                </td>
                            </tr>
                            <tr>
                                <td className="text-h3 text-off">

                                    <table>
                                        <tr>
                                            <td>
                                                Terms and conditions
                                            </td>
                                            <td width={30}>
                                                <div className="text-r bold">{print_trams_footer.length - 100}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <textarea className="text-h2" maxLength={100}
                                        value={print_trams_footer} onChange={(e) => setPrint_terms_footer(e.target.value)}
                                        placeholder="Print contact info option" />
                                </td>
                            </tr>
                            <tr>
                                <td className="text-h3 text-off">

                                    <table>
                                        <tr>
                                            <td>
                                                Contact info
                                            </td>
                                            <td width={30}>
                                                <div className="text-r bold">{print_contact_info_footer.length - 50}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <input className="text-h2" maxLength={50}
                                        value={print_contact_info_footer} onChange={(e) => setPrint_contact_info_footer(e.target.value)}
                                        placeholder="Print contact info option" />
                                </td>
                            </tr>
                            <tr>
                                <td className="text-h3 text-off">

                                    <table>
                                        <tr>
                                            <td>
                                                Address
                                            </td>
                                            <td width={30}>
                                                <div className="text-r bold">{print_address_footer.length - 50}</div>
                                            </td>
                                        </tr>
                                    </table>
                                </td>

                            </tr>
                            <tr>
                                <td>
                                    <textarea className="text-h2"
                                        value={print_address_footer} onChange={(e) => setPrint_address_footer(e.target.value)}
                                        maxLength={50} placeholder="Print address option" />
                                </td>
                            </tr>



                        </table>
                        <div onClick={() => set_print_setting()} className="button-ui cursor text-h2 bold fill p-2"><MdPrint className="icon" /> Save</div>
                    </div>
                </div>

            </div>


        </div>
    );
}